<template>
    <div>
        <v-card class="mx-auto mt-4" max-width="95%" elevation="2" style="overflow-x: auto;">
            <v-toolbar color="#37474F" dark class="flex-wrap" style="height: auto;">
                <v-toolbar-title>개발 유틸리티</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text class="pa-6">
                <!-- 테스트 타입 선택 -->
                <div class="mb-6">
                    <div class="d-flex align-center mb-4">
                        <v-icon color="primary" class="mr-2">mdi-toggle-switch</v-icon>
                        <h3 class="text-h6 font-weight-bold">테스트 타입 선택</h3>
                    </div>
                    <v-divider class="mb-4"></v-divider>
                    <v-btn-toggle
                        v-model="selectedTestType"
                        mandatory
                        color="primary"
                        class="mb-4 flex-wrap"
                    >
                        <v-btn value="realtime">
                            <v-icon left>mdi-bell-ring</v-icon>
                            실시간 알림 테스트
                        </v-btn>
                        <v-btn value="review">
                            <v-icon left>mdi-star</v-icon>
                            리뷰 테스트
                        </v-btn>
                        <v-btn value="offerwall">
                            <v-icon left>mdi-cash-multiple</v-icon>
                            오퍼월 테스트 지급
                        </v-btn>
                        <v-btn value="push">
                            <v-icon left>mdi-send</v-icon>
                            푸시전송 테스트
                        </v-btn>
                        <v-btn value="point">
                            <v-icon left>mdi-gift</v-icon>
                            포인트 지급
                        </v-btn>
                    </v-btn-toggle>
                </div>

                <!-- 실시간 알림 전송 섹션 -->
                <div v-if="selectedTestType === 'realtime'" class="mb-6">
                    <div class="d-flex align-center mb-4">
                        <v-icon color="primary" class="mr-2">mdi-bell-ring</v-icon>
                        <h3 class="text-h6 font-weight-bold">실시간 알림 전송</h3>
                    </div>
                    <v-divider class="mb-4"></v-divider>
                    
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="form_user_id"
                                label="사용자 ID *"
                                outlined
                                dense
                                prepend-inner-icon="mdi-account"
                                :rules="[v => !!v || '사용자 ID를 입력해주세요']"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="form_msg_tag"
                                label="메시지 태그 *"
                                outlined
                                dense
                                prepend-inner-icon="mdi-tag"
                                :rules="[v => !!v || '메시지 태그를 입력해주세요']"
                                hint="예: Noti_Event, Noti_Event_All, Msg_User_Target, Msg_User_All"
                                persistent-hint
                                placeholder="Noti_Event"
                            />
                        </v-col>
                    </v-row>

                    <!-- 메시지 태그 설명 카드 -->
                    <v-card
                        v-if="selected_msg_tag_info"
                        outlined
                        class="mb-4"
                        color="grey lighten-5"
                    >
                        <v-card-text>
                            <div class="d-flex align-center mb-2">
                                <v-icon :color="selected_msg_tag_info.color || 'info'" class="mr-2">
                                    {{ selected_msg_tag_info.icon || 'mdi-information' }}
                                </v-icon>
                                <span class="font-weight-bold">{{ selected_msg_tag_info.label }}</span>
                            </div>
                            <v-divider class="mb-2"></v-divider>
                            <div class="text-body-2">
                                <div class="mb-2">
                                    <strong>설명:</strong> {{ selected_msg_tag_info.description }}
                                </div>
                                <div v-if="selected_msg_tag_info.required_fields" class="mb-2">
                                    <strong>필수 필드:</strong>
                                    <v-chip
                                        v-for="field in selected_msg_tag_info.required_fields"
                                        :key="field"
                                        small
                                        color="primary"
                                        class="ml-1"
                                    >
                                        {{ field }}
                                    </v-chip>
                                </div>
                                <div v-if="selected_msg_tag_info.example" class="mt-2">
                                    <strong>예시 JSON:</strong>
                                    <pre class="mt-1 example-json">{{ selected_msg_tag_info.example }}</pre>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>

                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="form_user_message"
                                label="메시지 JSON *"
                                outlined
                                dense
                                rows="8"
                                prepend-inner-icon="mdi-code-json"
                                hint="JSON 형식으로 메시지를 직접 작성하세요. 위의 예시를 참고하세요."
                                persistent-hint
                                :rules="[
                                    v => !!v || '메시지 JSON을 입력해주세요',
                                    v => isValidJson(v) || '유효한 JSON 형식이 아닙니다'
                                ]"
                                placeholder='예: { "noti_type": "mail", "push_msg": "새로운 우편이 있습니다." }'
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="primary"
                                large
                                @click="OnSendNotification"
                                :loading="loadingData"
                                :disabled="!isRealtimeFormValid"
                            >
                                <v-icon left>mdi-send</v-icon>
                                알림 전송
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>

                <!-- 리뷰 테스트 섹션 -->
                <div v-if="selectedTestType === 'review'" class="mb-6">
                    <div class="d-flex align-center mb-4">
                        <v-icon color="primary" class="mr-2">mdi-star</v-icon>
                        <h3 class="text-h6 font-weight-bold">리뷰 테스트</h3>
                    </div>
                    <v-divider class="mb-4"></v-divider>
                    
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="review_attr_id"
                                label="유저 ID (attr_id) *"
                                outlined
                                dense
                                prepend-inner-icon="mdi-account"
                                :rules="[v => !!v || '유저 ID를 입력해주세요']"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="review_actn_cd"
                                label="액션 코드 (actn_cd)"
                                outlined
                                dense
                                prepend-inner-icon="mdi-code-tags"
                                hint="기본값: REVIEW"
                                persistent-hint
                                placeholder="REVIEW"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="primary"
                                large
                                @click="OnSendReviewTest"
                                :loading="loadingData"
                                :disabled="!isReviewFormValid"
                            >
                                <v-icon left>mdi-send</v-icon>
                                리뷰 테스트 전송
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>

                <!-- 오퍼월 테스트 지급 섹션 -->
                <div v-if="selectedTestType === 'offerwall'" class="mb-6">
                    <div class="d-flex align-center mb-4">
                        <v-icon color="primary" class="mr-2">mdi-cash-multiple</v-icon>
                        <h3 class="text-h6 font-weight-bold">오퍼월 테스트 지급</h3>
                    </div>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="offerwall_provider"
                                :items="offerwall_provider_options"
                                item-text="label"
                                item-value="value"
                                label="오퍼월 종류 *"
                                outlined
                                dense
                                prepend-inner-icon="mdi-storefront"
                                hint="포인트공장이 지원하는 오퍼월. 선택한 곳으로 샘플 포스트백을 전송합니다."
                                persistent-hint
                            />
                        </v-col>
                    </v-row>

                    <!-- Snapplay 전용: 최근 수집된 adv_id 선택 (PUBLIC_ADV_ID_DAILY 최신) -->
                    <v-row v-if="offerwall_provider === 'snapplay'">
                        <v-col cols="12">
                            <v-select
                                v-model="offerwall_adv_id"
                                :items="offerwall_adv_id_options"
                                label="adv_id (최근 수집)"
                                outlined
                                dense
                                clearable
                                :loading="offerwall_adv_loading"
                                prepend-inner-icon="mdi-bullhorn"
                                :hint="offerwall_adv_id_target_dt ? ('수집일 ' + offerwall_adv_id_target_dt + ' · ' + offerwall_adv_id_options.length + '개') : '최근 수집된 adv_id 목록'"
                                persistent-hint
                            >
                                <template v-slot:append-outer>
                                    <v-btn icon small :loading="offerwall_adv_loading" @click="loadAdvIds" title="adv_id 새로고침">
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="offerwall_pub_user_nm"
                                label="유저 아이디 *"
                                outlined
                                dense
                                prepend-inner-icon="mdi-account"
                                :rules="[v => !!v || '유저 아이디를 입력해주세요']"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="offerwall_user_pnt"
                                label="지급 포인트 (user_pnt) *"
                                outlined
                                dense
                                prepend-inner-icon="mdi-cash"
                                type="number"
                                :rules="[v => !!v || '지급 포인트를 입력해주세요', v => v > 0 || '0보다 큰 값을 입력해주세요']"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="primary"
                                large
                                @click="OnSendOfferwallTest"
                                :loading="loadingData"
                                :disabled="!isOfferwallFormValid"
                            >
                                <v-icon left>mdi-send</v-icon>
                                오퍼월 테스트 지급
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>

                <!-- 푸시전송 테스트 섹션 -->
                <div v-if="selectedTestType === 'push'" class="mb-6">
                    <div class="d-flex align-center mb-4">
                        <v-icon color="primary" class="mr-2">mdi-send</v-icon>
                        <h3 class="text-h6 font-weight-bold">푸시전송 테스트</h3>
                    </div>
                    <v-divider class="mb-4"></v-divider>
                    
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="push_push_token"
                                label="푸시 토큰 (PUSH_TOKEN) *"
                                outlined
                                dense
                                prepend-inner-icon="mdi-key"
                                :rules="[v => !!v || '푸시 토큰을 입력해주세요']"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="push_user_message"
                                label="메시지 (USER_MESSAGE) *"
                                outlined
                                dense
                                prepend-inner-icon="mdi-message-text"
                                :rules="[v => !!v || '메시지를 입력해주세요']"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="push_title"
                                label="제목 (TITLE)"
                                outlined
                                dense
                                prepend-inner-icon="mdi-format-title"
                                hint="기본값: 새로운 소식!"
                                persistent-hint
                                placeholder="새로운 소식!"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="push_user_id"
                                label="사용자 ID (USER_ID)"
                                outlined
                                dense
                                prepend-inner-icon="mdi-account"
                                hint="선택 사항"
                                persistent-hint
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="primary"
                                large
                                @click="OnSendPushTest"
                                :loading="loadingData"
                                :disabled="!isPushFormValid"
                            >
                                <v-icon left>mdi-send</v-icon>
                                푸시 전송
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>

                <!-- 포인트 지급 섹션 -->
                <div v-if="selectedTestType === 'point'" class="mb-6">
                    <div class="d-flex align-center mb-4">
                        <v-icon color="primary" class="mr-2">mdi-gift</v-icon>
                        <h3 class="text-h6 font-weight-bold">포인트 지급</h3>
                    </div>
                    <v-divider class="mb-4"></v-divider>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="point_user_id"
                                label="유저 ID *"
                                outlined dense
                                prepend-inner-icon="mdi-account"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model.number="point_amount"
                                label="지급 포인트 *"
                                type="number"
                                outlined dense
                                prepend-inner-icon="mdi-cash"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="point_reason"
                                label="지급 사유"
                                outlined dense
                                prepend-inner-icon="mdi-text"
                                placeholder="테스트 지급"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn color="primary" large @click="OnSendPoint" :loading="loadingData" :disabled="!isPointFormValid">
                                <v-icon left>mdi-send</v-icon>
                                포인트 지급
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>

                <!-- 응답 결과 섹션 -->
                <v-divider class="my-6"></v-divider>
                <div class="mb-6">
                    <div class="d-flex align-center mb-4">
                        <v-icon color="success" class="mr-2">mdi-code-json</v-icon>
                        <h3 class="text-h6 font-weight-bold">응답 결과</h3>
                    </div>
                    <v-divider class="mb-4"></v-divider>
                    
                    <v-card
                        v-if="responseData"
                        outlined
                        class="pa-4"
                        :color="responseSuccess ? 'success lighten-5' : 'error lighten-5'"
                    >
                        <div class="d-flex align-center mb-2">
                            <v-icon :color="responseSuccess ? 'success' : 'error'" class="mr-2">
                                {{ responseSuccess ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                            </v-icon>
                            <span class="font-weight-bold">{{ responseSuccess ? '성공' : '실패' }}</span>
                        </div>
                        <pre class="response-json">{{ formatResponse(responseData) }}</pre>
                    </v-card>

                    <v-card
                        v-else
                        outlined
                        class="pa-4 grey lighten-4"
                    >
                        <div class="text-center grey--text">
                            <v-icon class="mr-2">mdi-information-outline</v-icon>
                            응답 결과가 여기에 표시됩니다.
                        </div>
                    </v-card>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import config from '../../config/config';

export default {
    name: 'DevUtil',

    data: () => ({
        loadingData: false,
        selectedTestType: 'realtime',
        // 실시간 알림 테스트
        form_user_id: '',
        form_msg_tag: '',
        form_user_message: '',
        // 리뷰 테스트
        review_attr_id: '',
        review_actn_cd: '',
        // 오퍼월 테스트
        offerwall_pub_user_nm: '',
        offerwall_user_pnt: '',
        offerwall_provider: 'snapplay',
        offerwall_adv_id: '',
        offerwall_adv_id_options: [],
        offerwall_adv_id_target_dt: null,
        offerwall_adv_loading: false,
        offerwall_provider_options: [
            { value: 'snapplay', label: 'Snapplay' },
            { value: 'adjo', label: 'ADJO' },
            { value: 'cpx_aos', label: 'CPX (AOS)' },
            { value: 'cpx_ios', label: 'CPX (iOS)' },
            { value: 'dt', label: 'DT' },
            { value: 'gmo', label: 'GMO' },
            { value: 'house', label: 'House(자체)' },
            { value: 'maf', label: 'MAF' },
            { value: 'mallpie', label: 'Mallpie' },
            { value: 'nas_aos', label: 'NSTATION (AOS)' },
            { value: 'nas_ios', label: 'NSTATION (iOS)' },
            { value: 'pincrux', label: 'Pincrux' },
            { value: 'tnk', label: 'TNK' },
            { value: 'tyrads', label: 'TyrAds' },
        ],
        // 푸시 테스트
        push_push_token: '',
        push_user_message: '',
        push_title: '',
        push_user_id: '',
        // 포인트 지급
        point_user_id: '',
        point_amount: '',
        point_reason: '',
        responseData: null,
        responseSuccess: false,
        msg_tag_options: [
            {
                label: 'Noti_Event (일반 유저에게 알림)',
                value: 'Noti_Event',
                description: '일반 유저에게 알림을 전송합니다.',
                required_fields: ['noti_type', 'push_msg'],
                example: JSON.stringify({ noti_type: 'mail', push_msg: '새로운 우편이 있습니다.' }, null, 2),
                color: 'info',
                icon: 'mdi-bell-outline'
            },
            {
                label: 'Noti_Event_All (모든 유저에게 알림)',
                value: 'Noti_Event_All',
                description: '모든 유저에게 알림을 전송합니다.',
                required_fields: ['noti_type', 'push_msg'],
                example: JSON.stringify({ noti_type: 'event', push_msg: '새로운 이벤트가 시작되었습니다.' }, null, 2),
                color: 'primary',
                icon: 'mdi-bell-ring'
            },
            {
                label: 'Msg_User_Target (1:1 채팅전용)',
                value: 'Msg_User_Target',
                description: '특정 유저에게 1:1 채팅 메시지를 전송합니다.',
                required_fields: [],
                example: JSON.stringify({ message: '안녕하세요!' }, null, 2),
                color: 'success',
                icon: 'mdi-message-text'
            },
            {
                label: 'Msg_User_All (공개 채팅)',
                value: 'Msg_User_All',
                description: '공개 채팅 및 사용하기에 따라 골든벨도 사용할 수 있습니다.',
                required_fields: [],
                example: JSON.stringify({ message: '공개 메시지입니다.' }, null, 2),
                color: 'warning',
                icon: 'mdi-message-multiple'
            }
        ],
    }),

    computed: {
        isRealtimeFormValid() {
            return this.form_user_id && 
                   this.form_msg_tag && 
                   this.form_user_message && 
                   this.isValidJson(this.form_user_message);
        },
        isReviewFormValid() {
            return !!this.review_attr_id;
        },
        isOfferwallFormValid() {
            return !!this.offerwall_provider &&
                   !!this.offerwall_pub_user_nm &&
                   !!this.offerwall_user_pnt &&
                   Number(this.offerwall_user_pnt) > 0;
        },
        isPushFormValid() {
            return !!this.push_push_token && !!this.push_user_message;
        },
        isPointFormValid() {
            return !!this.point_user_id && !!this.point_amount && Number(this.point_amount) > 0;
        },
        isLive() {
            return config.isLive;
        },
        selected_msg_tag_info() {
            if (!this.form_msg_tag) return null;
            return this.msg_tag_options.find(option => option.value === this.form_msg_tag);
        }
    },

    methods: {
        ...mapActions([
            'PNTF_SEND_REALTIME_NOTIFICATION',
            'PNTF_SEND_PUSH_TEST',
            'PNTF_OFFERWALL_RECEIVE_SNAPPLAY',
            'PNTF_OFFERWALL_TEST',
            'PNTF_GET_RECENT_ADV_IDS',
            'PNTF_RECEIVE_SNAPPLAY_REVIEW_EVENT',
            'PNTF_DEV_GIVE_POINT',
        ]),

        async OnSendNotification() {
            if (!this.isRealtimeFormValid) {
                alert('모든 필수 항목을 입력해주세요.');
                return;
            }

            this.loadingData = true;
            this.responseData = null;
            this.responseSuccess = false;

            try {
                // JSON 문자열을 파싱하여 객체로 변환
                let parsedMessage;
                try {
                    parsedMessage = JSON.parse(this.form_user_message);
                } catch (e) {
                    alert('메시지 JSON 형식이 올바르지 않습니다. 다시 확인해주세요.');
                    this.loadingData = false;
                    return;
                }

                const response = await this.PNTF_SEND_REALTIME_NOTIFICATION({
                    user_id: this.form_user_id,
                    msg_tag: this.form_msg_tag,
                    user_message: parsedMessage
                });

                this.responseData = response;
                this.responseSuccess = true;
                alert('실시간 알림이 성공적으로 전송되었습니다.');
            } catch (err) {
                this.responseData = { error: err || '알 수 없는 오류' };
                this.responseSuccess = false;
                console.error('실시간 알림 전송 실패:', err);
                alert('실시간 알림 전송에 실패했습니다: ' + (err || '알 수 없는 오류'));
            } finally {
                this.loadingData = false;
            }
        },

        async OnSendReviewTest() {
            if (!this.isReviewFormValid) {
                alert('유저 ID를 입력해주세요.');
                return;
            }

            this.loadingData = true;
            this.responseData = null;
            this.responseSuccess = false;

            try {
                const response = await this.PNTF_RECEIVE_SNAPPLAY_REVIEW_EVENT({
                    attr_id: this.review_attr_id,
                    actn_cd: this.review_actn_cd || 'REVIEW'
                });

                this.responseData = response;
                this.responseSuccess = true;
                alert('리뷰 테스트가 성공적으로 전송되었습니다.');
            } catch (err) {
                this.responseData = { error: err || '알 수 없는 오류' };
                this.responseSuccess = false;
                console.error('리뷰 테스트 전송 실패:', err);
                alert('리뷰 테스트 전송에 실패했습니다: ' + (err || '알 수 없는 오류'));
            } finally {
                this.loadingData = false;
            }
        },

        async loadAdvIds() {
            this.offerwall_adv_loading = true;
            try {
                const r = await this.PNTF_GET_RECENT_ADV_IDS();
                const list = (r && Array.isArray(r.adv_ids)) ? r.adv_ids : [];
                this.offerwall_adv_id_options = list.map(String);
                this.offerwall_adv_id_target_dt = (r && r.target_dt) ? String(r.target_dt).slice(0, 10) : null;
                // 기존 선택값이 목록에 없거나 비어있으면 첫 항목으로
                if (this.offerwall_adv_id_options.length && !this.offerwall_adv_id_options.includes(this.offerwall_adv_id)) {
                    this.offerwall_adv_id = this.offerwall_adv_id_options[0];
                }
            } catch (e) {
                console.error('adv_id 목록 로드 실패:', e);
            } finally {
                this.offerwall_adv_loading = false;
            }
        },

        async OnSendOfferwallTest() {
            if (!this.isOfferwallFormValid) {
                alert('모든 필수 항목을 입력해주세요.');
                return;
            }

            this.loadingData = true;
            this.responseData = null;
            this.responseSuccess = false;

            try {
                const response = await this.PNTF_OFFERWALL_TEST({
                    provider: this.offerwall_provider,
                    user_id: this.offerwall_pub_user_nm,
                    user_pnt: Number(this.offerwall_user_pnt),
                    adv_id: this.offerwall_provider === 'snapplay' ? this.offerwall_adv_id : undefined
                });

                this.responseData = response;
                this.responseSuccess = true;
                alert('오퍼월 테스트 지급이 성공적으로 전송되었습니다.');
            } catch (err) {
                this.responseData = { error: err || '알 수 없는 오류' };
                this.responseSuccess = false;
                console.error('오퍼월 테스트 지급 실패:', err);
                alert('오퍼월 테스트 지급에 실패했습니다: ' + (err || '알 수 없는 오류'));
            } finally {
                this.loadingData = false;
            }
        },

        async OnSendPushTest() {
            if (!this.isPushFormValid) {
                alert('푸시 토큰과 메시지를 입력해주세요.');
                return;
            }

            this.loadingData = true;
            this.responseData = null;
            this.responseSuccess = false;

            try {
                const response = await this.PNTF_SEND_PUSH_TEST({
                    push_token: this.push_push_token,
                    user_message: this.push_user_message,
                    title: this.push_title || '새로운 소식!',
                    user_id: this.push_user_id || undefined
                });

                this.responseData = response;
                this.responseSuccess = true;
                alert('푸시 전송이 성공적으로 완료되었습니다.');
            } catch (err) {
                this.responseData = { error: err || '알 수 없는 오류' };
                this.responseSuccess = false;
                console.error('푸시 전송 실패:', err);
                alert('푸시 전송에 실패했습니다: ' + (err || '알 수 없는 오류'));
            } finally {
                this.loadingData = false;
            }
        },

        async OnSendPoint() {
            if (!this.isPointFormValid) { alert('유저 ID와 포인트를 입력해주세요.'); return; }
            this.loadingData = true;
            this.responseData = null;
            this.responseSuccess = false;
            try {
                const response = await this.PNTF_DEV_GIVE_POINT({
                    user_id: this.point_user_id,
                    amount: Number(this.point_amount),
                    reason: this.point_reason || '테스트 지급'
                });
                this.responseData = response;
                this.responseSuccess = true;
                alert('포인트 지급이 완료되었습니다.');
            } catch (err) {
                this.responseData = { error: err || '알 수 없는 오류' };
                this.responseSuccess = false;
                alert('포인트 지급 실패: ' + (err || '알 수 없는 오류'));
            } finally { this.loadingData = false; }
        },

        formatResponse(data) {
            if (!data) return '';
            try {
                return JSON.stringify(data, null, 2);
            } catch (e) {
                return String(data);
            }
        },

        onMsgTagChange() {
            // 메시지 태그 변경 시 처리 (필요시)
        },

        isValidJson(str) {
            if (!str || str.trim() === '') return true; // 빈 값은 required 규칙에서 처리
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                return false;
            }
        }
    },
    watch: {
        // 스냅오퍼월 선택 시(초기값 포함) 최근 adv_id 목록 자동 로드
        offerwall_provider: {
            immediate: true,
            handler(v) {
                if (v === 'snapplay' && this.offerwall_adv_id_options.length === 0 && !this.offerwall_adv_loading) {
                    this.loadAdvIds();
                }
            }
        }
    }
};
</script>

<style scoped>
.response-json {
    background-color: rgba(0, 0, 0, 0.05);
    padding: 16px;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 14px;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 400px;
    overflow-y: auto;
}

.example-json {
    background-color: rgba(0, 0, 0, 0.03);
    padding: 12px;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
}
</style>

